export default {
  state: {
    keepLiveCache: null,
    currentMenu: "home",
    tabList: [
      {
        id: "0",
        path: "/home",
        name: "home",
        title: "首页",
      }
    ]
  },

  mutations: {
    //保存keepLive缓存
    initKeepLive(state, value) {
      state.keepLiveCache = value;
    },

    //清除已关闭标签的缓存
    removeKeepLive(state, value) {
      //keepLive节点
      let parentVnode = state.keepLiveCache;
      
      if (parentVnode && parentVnode.componentInstance.cache && parentVnode.componentInstance.keys) {
        let cache = parentVnode.componentInstance.cache;
        let keys = parentVnode.componentInstance.keys;
        
        for (let i = 0; i < keys.length; i++) {
          if (value == keys[i]) {
            
            if (cache[keys[i]]) {
              delete cache[keys[i]];
              keys.splice(i, 1);
              break;
            }
          }
        }
      }
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////
    addTag(state, item) {
      state.currentMenu = item.name;
      let result = state.tabList.findIndex(val => val.name == item.name);
      if (result === -1) {
        state.tabList.push(item);
      }
    },

    delTag(state, item) {
      let result = state.tabList.findIndex(val => val.name === item.name);
      if (result !== -1) {
        state.tabList.splice(result, 1);
      }
    },

    clearTag(state) {
      state.tabList = [];

      const homeMenu = {
        id: "0",
        path: "/home",
        name: "home",
        title: "首页",
      }
      state.tabList.push(homeMenu);
      state.currentMenu = 'home';
    },

    setCurrentMenu(state, currentMenuName) {
      state.currentMenu = currentMenuName;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/tab.js